export const mainRoutes = [
	{
		path: "main/:id",
		name: "main",
		component: () => import('../pages/main-page.vue'),
	},
];
